module.exports = __webpack_public_path__ + "img/collection-edition-ii.cb582682.jpg";